var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 6.66667C3.33301 6.29867 3.63167 6 3.99967 6H21.333C21.701 6 21.9997 6.29867 21.9997 6.66667C21.9997 7.03467 21.701 7.33333 21.333 7.33333H3.99967C3.63167 7.33333 3.33301 7.03467 3.33301 6.66667ZM27.9997 15.3333H3.99967C3.63167 15.3333 3.33301 15.632 3.33301 16C3.33301 16.368 3.63167 16.6667 3.99967 16.6667H27.9997C28.3677 16.6667 28.6663 16.368 28.6663 16C28.6663 15.632 28.3677 15.3333 27.9997 15.3333ZM15.9997 24.6667H3.99967C3.63167 24.6667 3.33301 24.9653 3.33301 25.3333C3.33301 25.7013 3.63167 26 3.99967 26H15.9997C16.3677 26 16.6663 25.7013 16.6663 25.3333C16.6663 24.9653 16.3677 24.6667 15.9997 24.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6df9db5be824752d540499ba1305bec7.svg";
export { ForwardRef as ReactComponent };